
export default {
  props: {
    html: { type: String, default: '' },
  }
};
